<template>
  <div>
    <el-row>
      <el-col :span="18">
        <el-button v-if="operationHas" type="primary" @click="add">新增</el-button>
        <el-button type="primary"
                   v-if="this.currentMenuOperations.some(func => func.name.includes('export'))"
                   @click="device_export">导出
        </el-button>
        <el-upload
          v-if="this.currentMenuOperations.some(func => func.name.includes('batch'))"
          style="display:inline-block;margin: 0 10px;"
          ref="upload"
          :on-success="handleSuccess"
          :on-error="handleError"
          :action="baseUrl3+'device/batch/import'"
          :show-file-list="false"
          name="file"
          :headers="{
                  Authorization: 'Bearer ' + token
                }"
        >
          <el-button type="primary">批量导入</el-button>
        </el-upload>
        <a v-if="nginxUrl"
           :href="nginxUrl+baseUrl3 + 'device/getTemplate'">
          <el-button type="text">下载模版</el-button>
        </a>
        <a v-else :href="baseUrl3 + 'device/getTemplate'">
          <el-button type="text">下载模版</el-button>
        </a>

      </el-col>
      <el-col :span="6">
        <!-- <el-input v-model="search" size="mini" placeholder="输入关键字搜索" /> -->
        <el-input v-model="search" placeholder="搜索" @change="getDatas">
          <el-button slot="append" icon="el-icon-search" @click="getDatas"></el-button>
        </el-input>
      </el-col>
    </el-row>
    <el-table
      :data="tables"
      :default-sort="{prop: 'id', order: 'descending'}"
      row-key="id"
      tooltip-effect="light"
      style="width: 100%"
      @selection-change="selectionChange"
    >
      <el-table-column type="selection" width="55"
                       :reserve-selection="true"
                       v-if="this.currentMenuOperations.some(func => func.name.includes('export'))"></el-table-column>
      <el-table-column align="center" prop="name" label="名称"></el-table-column>
      <el-table-column align="center" prop="area" label="设备所在地"></el-table-column>
      <el-table-column align="center" prop="room" label="所属机房"></el-table-column>
      <el-table-column align="center" prop="deployIp" label="DeployIp"></el-table-column>
      <el-table-column align="center" prop="deployPort" label="Deploy端口"></el-table-column>
      <el-table-column align="center" prop="exchangeIp" label="ExchangeIp"></el-table-column>
      <el-table-column align="center" prop="exchangePort" label="Exchange端口"></el-table-column>
      <el-table-column align="center" prop="status" label="设备状态" :formatter="statusDesc"></el-table-column>
      <el-table-column align="center" label="操作" width="210px;" prop="functionList"
                       v-if="listOperations.length > 0"
      >
        <template slot-scope="scope">
          <!-- <el-button v-for="btn in listOperations" :key="btn.id"
            size="mini"
            type="primary"
            @click="go(btn, scope.row)"
          >{{btn.alias}}</el-button> -->
          <el-button v-if="listOperations.some(operation => operation.name.includes('edit'))"
                     size="mini"
                     type="primary"
                     @click="device_edit(scope.row)"
          >编辑
          </el-button>

          <el-button v-if="listOperations.some(operation => operation.name.includes('del'))"
                     size="mini"
                     type="danger"
                     @click="device_del(scope.row)"
          >删除
          </el-button>

          <el-dropdown trigger="click" style="margin-left: 10px;"
                       v-if="listOperations.some(operation => operation.name.includes('detect'))"
                       :hide-on-click="false"
                       @visible-change="visibleChange">
            <el-button type="primary" size="mini">探测</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <el-button size="mini" type="text" @click="device_detect_deploy(scope.row)">Deploy</el-button>
                <span>
                  <i class="el-icon-check" style="color:#67C23A;" v-if="detectPort.deploy"></i>
                  <i class="el-icon-close" style="color:#F56C6C;" v-if="detectPort.deploy == false"></i>
                </span>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button size="mini" type="text" @click="device_detect_exchange(scope.row)">Exchange</el-button>
                <span>
                  <i class="el-icon-check" style="color:#67C23A;" v-if="detectPort.exchange"></i>
                  <i class="el-icon-close" style="color:#F56C6C;" v-if="detectPort.exchange == false"></i>
                </span>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button size="mini" type="text" @click="device_detect_logs(scope.row)">Logs</el-button>
                <span>
                  <i class="el-icon-check" style="color:#67C23A;" v-if="detectPort.logs"></i>
                  <i class="el-icon-close" style="color:#F56C6C;" v-if="detectPort.logs == false"></i>
                </span>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button size="mini" type="text" @click="device_detect_all(scope.row.id)">所有端口</el-button>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="fy"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10,20,30,40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalElement"
    ></el-pagination>
    <device-edit v-if="showEdit"
                 :visible="showEdit"
                 @editCallback="editCallback"
                 :id="currentRow.id"/>

    <el-dialog :visible="delShow" title="提示" @close="delCancel">
      <span>您确定要删除吗？</span>
      <span slot="footer">
        <el-button @click="delCancel">取 消</el-button>
        <el-button type="primary" @click="del()">确 定</el-button>
      </span>
    </el-dialog>

    <device-detect-result
      :visible="showDetectBox"
      :results="detectResult"
      @closeBox="showDetectBox=false"/>
  </div>
</template>

<script>
  import {mapState, mapMutations} from 'vuex';
  import {Loading} from "element-ui";
  import DeviceEdit from './DeviceEdit.vue'
  import DeviceDetectResult from './DeviceDetectResult.vue'

  export default {
    name: "DeviceList",
    components: {DeviceEdit, DeviceDetectResult},
    data: vm => ({
      showEdit: false, //新增窗口
      search: null, //搜索关键字
      currentPage: 1,
      pageSize: 10,
      totalElement: 0,
      tables: [],
      delShow: false,
      currentRow: {},
      showOperation: true, //显示操作列
      operations: [],
      showDetectBox: false,
      detectResult: [], //设备探测
      detectPort: {
        deploy: null,
        exchange: null,
        logs: null,
      }, //探测结果显示
      checkedDeviceIds: []
    }),
    created() {
      this.getListOperations('device')
      if (!this.currentMenu) {
        return
      }
      this.getDatas()
    },
    computed: {
      ...mapState(['currentMenu', 'listOperations', 'currentMenuOperations']),
      operationHas() {
        return this.currentMenuOperations ? this.currentMenuOperations.some(func => func.name.includes('addItem')) : false
      },
      token() {
        return localStorage.getItem('token')
      }
    },
    watch: {
      search: {
        handler(newVal, oldVal) {
          if (!newVal) {
            this.search = null
          }
          this.currentPage = 1
          this.pageSize = 10
        }
      }
    },
    methods: {
      ...mapMutations(['getListOperations']),
      go(btn, row) {
        this[btn.name](row)
      },
      device_export() {
        let args = this.checkedDeviceIds
        if (args.length == this.totalElement || args.length == 0) {
          args = null
        } else {
          args = args.join(',')
        }
        let url = this.baseUrl3 + "device/export/" + args;
        if (this.nginxUrl) {
          window.location.href = this.nginxUrl + url
        } else {
          window.location.href = url
        }

      },
      // 勾选的数据
      selectionChange(selection) {
        let arr = []
        selection.forEach(select => {
          arr.push(select.id)
        })
        this.checkedDeviceIds = arr
      },
      handleSuccess({code, msg, data}, file, fileList) {
        if (code == 20000) {
          this.$message.success('操作成功')
          this.currentPage = 1
          this.pageSize = 10
          this.getDatas()
        } else {
          this.$message.error("上传失败！原因：" + msg);
        }
      },
      handleError(err, file, fileList) {
        this.$message({showClose: true, message: "上传失败", type: "error"});
        console.log("error=" + err);
      },
      visibleChange(visible) {
        if (!visible) {
          this.detectPort = {
            deploy: null,
            exchange: null,
            logs: null
          }
        }
      },
      add() {
        this.showEdit = true;
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getDatas()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getDatas()
      },
      editCallback() {
        this.currentRow = {}
        this.showEdit = false
        this.getDatas()
      },
      getDatas() {
        let model = {
          pageNo: this.currentPage,
          pageSize: this.pageSize
        };
        let loading = Loading.service({
          fullscreen: true,
          text: "数据加载中..."
        });
        this.$axios
          .get(
            this.baseUrl3 +
            "device/findByPageLike/" +
            model.page +
            "/" +
            model.pageSize + '/' + this.search
          )
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              this.tables = data.list;
              this.totalElement = data.total;
            } else {
              this.$message({showClose: true, message: msg, type: "error"});
              console.log(msg);
            }
            loading.close();
          })
          .catch(error => {
            loading.close();
            this.$message({
              showClose: true,
              message: "系统异常",
              type: "error"
            });
            console.log(error);
          });
      },
      statusDesc(row) {
        return row.status == 0 ? '正常' : '不使用'
      },
      device_del(row) {
        this.delShow = true
        this.currentRow = row
      },
      delCancel() {
        this.delShow = false
        this.currentRow = {}
      },
      del() {
        this.delShow = false
        const row = this.currentRow
        this.$axios
          .get(this.baseUrl3 + "device/del/" + row.id)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              this.getDatas();
              this.$message({
                type: "success",
                message: "删除成功!"
              });
            } else {
              this.$message({showClose: true, message: msg, type: "error"});
              console.log(msg);
            }
          })
          .catch(error => {
            this.$message({
              showClose: true,
              message: "系统异常",
              type: "error"
            });
            console.log(error);
          });
      },
      device_edit(row) {
        this.showEdit = true
        this.currentRow = row
      },
      // 探测端口
      device_detect_deploy(row) {
        this.detectPort.deploy = null
        let loading = Loading.service({
          fullscreen: true,
          text: "数据加载中..."
        });
        this.$axios.get(this.baseUrl3 + 'device/detect/' + row.id + '/deploy')
          .then(({data: {msg, data, code}}) => {
            this.detectPort.deploy = data
            loading.close()
          })
          .catch(e => {
            this.$message({message: e, type: "error"});
            console.log(e)
            loading.close()
          })
      },
      device_detect_exchange(row) {
        this.detectPort.exchange = null
        let loading = Loading.service({
          fullscreen: true,
          text: "数据加载中..."
        });
        this.$axios.get(this.baseUrl3 + 'device/detect/' + row.id + '/exchange')
          .then(({data: {msg, data, code}}) => {
            this.detectPort.exchange = data
            loading.close()
          })
          .catch(e => {
            this.$message({message: e, type: "error"});
            console.log(e)
            loading.close()
          })
      },
      device_detect_logs(row) {
        this.detectPort.logs = null
        let loading = Loading.service({
          fullscreen: true,
          text: "数据加载中..."
        });
        this.$axios.get(this.baseUrl3 + 'device/detect/' + row.id + '/logs')
          .then(({data: {msg, data, code}}) => {
            this.detectPort.logs = data
            loading.close()
          })
          .catch(e => {
            this.$message({message: e, type: "error"});
            console.log(e)
            loading.close()
          })
      },
      // 探测所有端口
      device_detect_all(id) {
        let loading = Loading.service({
          fullscreen: true,
          text: "数据加载中..."
        });
        this.$axios.get(this.baseUrl3 + 'device/detect/port/' + id)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              this.detectResult = data
              this.showDetectBox = true
            } else {
              this.$message({message: msg, type: "error"});
            }
            loading.close()
          })
          .catch(e => {
            this.$message({message: e, type: "error"});
            console.log(e)
            loading.close()
          })
      }
    }
  };
</script>
<style>
  .fy {
    text-align: center;
    margin-top: 30px;
  }

  a {
    text-decoration: none;
  }
</style>
